import { VisibilityOff } from "@mui/icons-material";
import { Box } from "@mui/material";
import type { JSX } from "react";

export default function UICustomizationPresetAvatar(): JSX.Element {
    return (
        <Box sx={{
            position: "relative",
            display: "flex"
        }}>
            <VisibilityOff fontSize="large" />
        </Box>
    );
}
